// extracted by mini-css-extract-plugin
module.exports = {"headingWrapper":"styles_headingWrapper__2Mtuv","wrapper":"styles_wrapper__13C6w"};